<div
  (click)="submitEvent.emit()"
  [ngClass]="class2"
  class="outline-none py-1 text-xs cursor-pointer rounded-full border border-solid mb-2 inline-block text-primary bg-white hover:bg-primary hover:text-white hover:border-transparent mr-2 md:mr-8 border-primary transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-110 font-bold"
>
  {{ title }}
</div>
